import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
  Snackbar, Alert
} from "@mui/material";

import { useMutation } from "@apollo/client";
import { DELETE_MUTATION } from "../graphql/mutations";

const DeleteConfirmationDialog = ({ open, onClose, user }) => {
  const [deletemutation] = useMutation(DELETE_MUTATION);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // 'success' | 'error'

  const handleDelete = async () => {
    console.log("Deleting member:", user);
    try {
      const { data } = await deletemutation({ variables: { id: user.id } });

      setSnackbarMessage("Member deleted successfully.");
      setSnackbarSeverity("success");
    } catch (error) {
      const apiMessage = error?.graphQLErrors?.[0]?.message || "Failed to delete member.";
      setSnackbarMessage(apiMessage);
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
      onClose();
      window.location.reload();
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const isSuperUser = user?.Role?.toLowerCase() === "superuser";

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete the following member?</Typography>
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            <b>Name:</b> {user?.First_Name || "N/A"}<br />
            <b>Member ID:</b> {user?.id || "N/A"}<br />
            <b>Mobile:</b> {user?.Mobile_Number || "N/A"}<br />
            <b>Role:</b> {user?.Role || "N/A"}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>

          <Button
            onClick={handleDelete}
            color={isSuperUser ? "error" : "error"}
            disabled={isSuperUser}
            sx={{
              color: "red",
              borderColor: isSuperUser ? "red" : "inherit",
              cursor: isSuperUser ? "not-allowed" : "pointer",
            }}
          >
            {isSuperUser ? "You can't delete Superuser" : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteConfirmationDialog;
